<template>
    <button
        class="bcc-verification"
        :disabled="disabled"
        @click.prevent="handleClick"
        :class="{'is-disabled': disabled}"
    >
      <transition name="bcc-verification-fade" v-if="popover">
        <div v-show="popoverShow" style="display: inline-block; vertical-align: middle">
          <div :class="'bcc-verification-popover popover-'+position">
            验证码已发送
          </div>
          <div :class="'bcc-verification-arrow popover-'+position"></div>
        </div>
      </transition>
      <span class="bcc-verification-seconds">{{time}}</span><span>{{content}}</span>
    </button>
</template>
<script>
export default {
  name: 'BccVerification',
  componentName: 'BccVerification',
  data () {
    return {
      content: '获取验证码',
      seconds: this.totalTime,
      time: null,
      canClick: true,
      popoverShow: false,
      timerClock: null
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default () {
        return false
      }
    },
    type: {
      type: String,
      default () {
        return 'default'
      }
    },
    size: {
      type: String,
      default () {
        return 'small'
      }
    },
    totalTime: {
      type: Number,
      default () {
        return 60
      }
    },
    isAsync: {
      type: Boolean,
      default () {
        return false
      }
    },
    position: {
      type: String,
      default () {
        return 'left'
      }
    },
    popover: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  methods: {
    handleClick () {
      if (!this.canClick) return
      if (this.isAsync) this.$emit('click', this.startCountDown)
      else {
        this.$emit('click')
        this.startCountDown()
      }
    },
    startCountDown () {
      this.popoverShow = true
      setTimeout(() => {
        this.popoverShow = false
      }, 3000)
      this.canClick = false
      this.time = this.seconds + 's'
      this.content = '后重新发送'
      let clock = setInterval(() => {
        this.time = --this.seconds + 's'
        if (this.seconds === 0) {
          window.clearInterval(clock)
          this.content = '重新获取'
          this.time = null
          this.seconds = this.totalTime
          this.canClick = true
          this.$emit('loop-end')
        }
      }, 1000)
      this.timerClock = clock
    }
  }
}
</script>
